import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Style
import {
  Container,
  StyledButton,
  CelebrationCheckIcon,
  TitleContainer,
  Title,
  TimelineContainer,
  TimelineBox,
  TimelineBoxIcon,
  TimelineText,
} from "./styles";

import { SHOW_STORE_PROVISIONING_MODAL } from "~/helpers/customEvents";
import Modal from "~/components/ui/Modal";
import { useModalTrigger } from "~/hooks/useModalTrigger";

type StoreProvisioningModalProps = {
  onExplore: () => void;
};

export const StoreProvisioningModal = ({
  onExplore,
}: StoreProvisioningModalProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useModalTrigger(
    SHOW_STORE_PROVISIONING_MODAL,
    true
  );

  const handleExplore = () => {
    onExplore();
    setIsModalOpen(false);
  };

  return (
    <Modal
      id="store-provisioning-modal"
      hide={() => {
        setIsModalOpen(false);
        onExplore();
      }}
      isShowing={isModalOpen}
      padding="24px"
      minWidth="min(90%, 482px)">
      <Container data-testid="onboarding-store-provisioning-modal">
        <CelebrationCheckIcon />
        <TitleContainer>
          <Title>{t("storeProvisioningModal.Title")}</Title>
        </TitleContainer>
        <TimelineContainer>
          <TimelineBox>
            <TimelineBoxIcon>1</TimelineBoxIcon>
            <TimelineText>
              {t("storeProvisioningModal.Timeline.AccountConfirmation")}
            </TimelineText>
          </TimelineBox>

          <TimelineBox>
            <TimelineBoxIcon>2</TimelineBoxIcon>
            <TimelineText>
              {t("storeProvisioningModal.Timeline.CustomizationStarted")}
            </TimelineText>
          </TimelineBox>

          <TimelineBox>
            <TimelineBoxIcon>3</TimelineBoxIcon>
            <TimelineText>
              {t("storeProvisioningModal.Timeline.EmailLinkNotification")}
            </TimelineText>
          </TimelineBox>
        </TimelineContainer>
        <StyledButton
          title={t("storeProvisioningModal.Button.Title") as string}
          onClick={handleExplore}>
          {t("storeProvisioningModal.Button.Label")}
        </StyledButton>
      </Container>
    </Modal>
  );
};
